module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/home/pages/Dashboard/AdminDashboardPages/service-management/service-management.component.scss
// module id = ./src/app/home/pages/Dashboard/AdminDashboardPages/service-management/service-management.component.scss
// module chunks = main